/**
 * Schema-related data fetchers
 */
import { useQuery } from "@tanstack/react-query";

import { ConfigMap, EnabledFieldsMap, RequestedFieldsMap } from "@/src/lib/schema-types";
import { getConfig, getEnabledFields, getRequestedFields } from "@/src/requests/schema";

export function useEnabledFields() {
  return useQuery<EnabledFieldsMap>({
    queryKey: ["enabledFields"],
    queryFn: getEnabledFields,
    staleTime: Infinity,
    gcTime: Infinity,
  });
}

export function useRequestedFields() {
  return useQuery<RequestedFieldsMap>({
    queryKey: ["requestedFields"],
    queryFn: getRequestedFields,
    staleTime: Infinity,
    gcTime: Infinity,
  });
}

export function useConfig() {
  return useQuery<ConfigMap>({
    queryKey: ["config"],
    queryFn: getConfig,
    staleTime: Infinity,
    gcTime: Infinity,
  });
}
